import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Redirect } from 'react-router-dom';

import config from 'config';
import { useSigmaDashboardByUrlQuery } from 'generated/graphql';
import { useQueryParams } from 'utils/useQueryParams';
import { SigmaEmbed } from 'components/SigmaEmbed/SigmaEmbed';

const SigmaShadowDashboard: React.FC<{ url: string }> = ({ url }) => {
  const { data: dashboardData, loading } = useSigmaDashboardByUrlQuery({
    fetchPolicy: 'network-only',
    variables: {
      url,
    },
  });

  const sigmaUrl = dashboardData?.getSigmaDashboardForURL || '';

  if (loading) {
    return <LinearProgress />;
  }

  return <SigmaEmbed sigmaUrl={sigmaUrl} />;
};

const WrappedSigmaShadowDashboard = () => {
  const queryParams = useQueryParams();
  const unsafeUrl = queryParams.get('url') ?? '';

  if (config.isProduction) {
    // @NOTE-BG: Works only in non-prod environments. Is a security risk for production (allows iframe injection).
    return <Redirect to="/dashboards" />;
  }

  let url = '';
  try {
    const parsedUrl = new URL(unsafeUrl);
    url = parsedUrl.toString();
  } catch {
    return <Redirect to="/dashboards" />;
  }

  return <SigmaShadowDashboard url={url} />;
};

export default WrappedSigmaShadowDashboard;
